module.exports = {
  siteMetadata: {
    title: `PropertyLens`,
    siteUrl: `https://www.propertylens.com`,
    image: 'https://www.propertylens.com/images/default-hero-image.png',
    description: `Why risk it? Know before you buy. Avoid buying a home with costly hidden problems and repairs by putting it under the PropertyLens!`,
  },
}
